import {ReducerStatuses} from "services/utils/utils";
import {createSelector} from "@reduxjs/toolkit";
import {get} from "lodash";

const baseState = state => state.user.subscription;

export const getUserSubscriptionLoading = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const getUserSubscriptionErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const getUserSubscriptionData = createSelector([baseState], (state) => {
    return state.data;
});
export const getUserSubscriptionType = createSelector([baseState], (state) => {
    return get(state.data, 'plan', null);
});

